export class Announcement {    
    id: string;
    title: string;    
    body: string;
    expiryDate: string;
    fromDate:string;
   }


// WEBPACK FOOTER //
// ./src/app/modules/announcements/entities/announcement.ts